import * as React from "react"

// markup
const Title = (props) => {
  return (
   <h1 className="text-4xl md:text-5xl font-bold relative font-title">{props.title}</h1>
  )
}

export default Title
